import Vue from 'vue'
//import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import VueCookie from 'vue-cookie'
import Vuefire from 'vuefire'
import Firebase from './service/firebase'

Vue.config.productionTip = false

Vue.use(Vuefire)
Vue.use(VueCookie);

/*
Vue.use(Vuex)
  const state = {
  db: Firebase.firestore()
}
*/

new Vue({
/*
  firebase: {
    users: firebase.database.ref('users').orderByChild('created_at'),
    parties: firebase.database.ref('parties').orderByChild('created_at'),
    wishes: firebase.database.ref('wishes').orderByChild('created_at'),
    kids: firebase.database.ref('kids').orderByChild('created_at'),
    chats: firebase.database.ref('chats').orderByChild('created_at'),
    photos: firebase.database.ref('photos').orderByChild('created_at'),
  },
*/
  router,
  store,
  render: h => h(App)
}).$mount('#app')
